import React, { useEffect } from "react";
import { observer } from "mobx-react";
import ConnectLinkedInButton from "./ConnectLinkedInButton";
import { linkedInReplyState } from "./state";
import ConnectedLinkedInList from "./ConnectedLinkedInList";
import ConnectedLinkedInConfigure from "./ConnectedLinkedInConfigure";

const LinkedInAccounts = observer((props = {}) => {
  useEffect(() => {
    linkedInReplyState.setLinkedInDataLoading(true);
    linkedInReplyState.getLinkedInAccounts();
  }, []);

  // The Unipile OAuth flow redirects the popup it opened back to this same
  // page on both success and cancel. Best-effort tell the opener we're done
  // (requires window.opener, which a cross-origin hop can sever), then close
  // this window regardless - browsers already refuse to close a tab that
  // wasn't opened via window.open(), so this is a no-op on a normal visit to
  // this page and only actually closes the OAuth popup.
  useEffect(() => {
    if (window.opener && window.opener !== window) {
      try {
        window.opener.postMessage({ type: "LINKEDIN_OAUTH_POPUP_DONE" }, "*");
      } catch (e) {
        // ignore
      }
    }
    const timer = setTimeout(() => window.close(), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`connectLinkedInBody ${
        linkedInReplyState?.linkedInConnected ? "linkedInAccountConnected" : ""
      }`}
    >
      {linkedInReplyState?.linkedInConnected ? (
        linkedInReplyState?.showConfigure ? (
          <ConnectedLinkedInConfigure />
        ) : (
          <div className="connectedLinkedInAccountsBody">
            {/* <ConnectedLinkedInHeader /> */}
            <ConnectedLinkedInList />
          </div>
        )
      ) : (
        <ConnectLinkedInButton />
      )}
    </div>
  );
});

export { LinkedInAccounts };
export default LinkedInAccounts;
